// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"572":"1a1f35a5","917":"780a0762"}[chunkId] + ".chunk.js";
};